import { colorConstants } from 'config/colorConstants';
import { ChangeAnalyticsOutputType } from 'types/pricingSimulator';

export const changeAnalyticsChartParser = (graphId: number, count: number, data: any[]) => {
    try {
        let minVal = 0;
        let maxVal = 0;
        const result = data?.map((item: any) => {
            minVal = Math.min(minVal, item?.value);
            maxVal = Math.max(maxVal, item?.value);
            return {
                category: item?.attribute_name,
                sales: item?.value,
                labelSales: item?.value,
                color: Number(item?.value) < 0 ? colorConstants.red : colorConstants.limeGreen,
            };
        });
        let outputObj: ChangeAnalyticsOutputType = {
            count: count ?? 0,
            data: result,
            id: graphId,
            maxVal,
            minVal,
        };
        return outputObj;
    } catch (error) {
        throw error;
    }
};
